// For features that trigger an upgrade popup, the event is sent when the popup is shown.
export const UPGRADE_POPUP_TRIGGERED_EVENTS = {
    SM_LIMIT_UPGRADE_TRIGGERED: 'sm-limit-ap_upgrade_triggered',
    SM_LIMIT_CROWN_CARD_TRIGGERED: 'sm-limit-ap_upgrade_crown_triggered',
    ALIAS_CREATION_UPGRADE_TRIGGERED: 'alias-creation-ap_upgrade_triggered',
    VOICE_PARTICIPANT_LIMIT_UPGRADE_TRIGGERED: 'voice-participant-limit-ap_upgrade_triggered',
    SLA_DUE_SOON_UPGRADE_TRIGGERED: 'sla-due-soon_upgrade_triggered'
};

// Events for when an upgrade button is clicked
export const UPGRADE_BUTTON_CLICKED_EVENTS = {
    SM_LIMIT_UPGRADE_CLICKED: 'sm-limit-ap_upgrade_clicked',
    SM_LIMIT_CROWN_CARD_CLICKED: 'sm-limit-ap_upgrade_crown_clicked',
    VOICE_INBOX_UPGRADE_CLICKED: 'voiceinbox-ap_upgrade_crown_clicked',
    ALIAS_CREATION_UPGRADE_CLICKED: 'alias-creation-ap_upgrade_clicked',
    CUSTOMER_PORTAL_UPGRADE_CLICKED: 'customer-portal-ap_upgrade_clicked',
    CUSTOM_FIELDS_UPGRADE_CLICKED: 'custom-fields-ap_upgrade_clicked',
    CUSTOM_FIELDS_CROWN_CARD_CLICKED: 'custom-fields-ap_upgrade_crown_clicked',
    AUTO_ASSIGNMENT_UPGRADE_CLICKED: 'auto-assignment-ap_upgrade_clicked',
    AUTO_ASSIGNMENT_CROWN_CARD_CLICKED: 'auto-assignment-ap_upgrade_crown_clicked',
    AUTOMATIONS_UPGRADE_CLICKED: 'automations-ap_upgrade_clicked',
    AUTOMATIONS_CROWN_CARD_CLICKED: 'automations-ap_upgrade_crown_clicked',
    AUTOMATIONS_NODE_UPGRADE_CLICKED: 'automation-nodes_upgrade_clicked',
    AUTO_RESPONDER_UPGRADE_CLICKED: 'auto-responder-ap_upgrade_clicked',
    SLA_UPGRADE_CLICKED: 'sla-ap_upgrade_clicked',
    SLA_CROWN_CARD_CLICKED: 'sla-ap_upgrade_crown_clicked',
    SLA_DUE_SOON_UPGRADE_CLICKED: 'sla-due-soon_upgrade_clicked',
    CSAT_UPGRADE_CLICKED: 'csat-ap_upgrade_clicked',
    APPROVALS_UPGRADE_CLICKED: 'approvals-ap_upgrade_clicked',
    BUSINESS_HOURS_TEMPLATE_UPGRADE_CLICKED: 'business-hours-template-ap_upgrade_clicked',
    CHAT_AUTO_ASSIGNMENT_UPGRADE_CLICKED: 'chat-auto-assignment-ap_upgrade_clicked',
    CHATBOTS_UPGRADE_CLICKED: 'chatbots-ap_upgrade_clicked',
    CHATBOTS_CROWN_CARD_CLICKED: 'chatbots-ap_upgrade_crown_clicked',
    CHAT_ARTICLES_UPGRADE_CLICKED: 'chat-articles-ap_upgrade_clicked',
    CHAT_TRANSCRIPTS_UPGRADE_CLICKED: 'chat-transcripts-ap_upgrade_clicked',
    CHAT_CONTACT_US_FORM_UPGRADE_CLICKED: 'chat-contact-us-form-ap_upgrade_clicked',
    ZAPIER_INTEGRATION_CROWN_CARD_CLICKED: 'zapier-integration-ap_upgrade_crown_clicked',
    EMAIL_PARTICIPANT_LIMIT_UPGRADE_CLICKED: 'email-participant-limit-ap_upgrade_clicked',
    VOICE_PARTICIPANT_LIMIT_UPGRADE_CLICKED: 'voice-participant-limit-ap_upgrade_clicked',
    SLACK_INTEGRATION_UPGRADE_CLICKED: 'slack-integration-ap_upgrade_clicked',
    SLACK_INTEGRATION_CROWN_CARD_CLICKED: 'slack-integration-ap_upgrade_crown_clicked',
    ASANA_INTEGRATION_UPGRADE_CLICKED: 'asana-integration-ap_upgrade_clicked',
    ASANA_INTEGRATION_CROWN_CARD_CLICKED: 'asana-integration-ap_upgrade_crown_clicked',
    JIRA_INTEGRATION_UPGRADE_CLICKED: 'jira-integration-ap_upgrade_clicked',
    JIRA_INTEGRATION_CROWN_CARD_CLICKED: 'jira-integration-ap_upgrade_crown_clicked',
    SALESFORCE_INTEGRATION_UPGRADE_CLICKED: 'salesforce-integration-ap_upgrade_clicked',
    SALESFORCE_INTEGRATION_CROWN_CARD_CLICKED: 'salesforce-integration-ap_upgrade_crown_clicked',
    QUICKBOOKS_INTEGRATION_UPGRADE_CLICKED: 'quickbooks-integration-ap_upgrade_clicked',
    QUICKBOOKS_INTEGRATION_CROWN_CARD_CLICKED: 'quickbooks-integration-ap_upgrade_crown_clicked',
};

// Events for when an upgrade button in an hover bar or tooltip is clicked
export const UPGRADE_TOOLTIP_CLICKED_EVENTS = {
    CUSTOM_ROLES_UPGRADE_CLICKED: 'customroles_upgrade_tooltip_clicked',
    ROLES_UPGRADE_CLICKED: 'roles_upgrade_tooltip_clicked',
    HARVEY_THANK_YOU_UPGRADE_CLICKED: 'harveytyd_upgrade_tooltip_clicked',
    EMAIL_TEMPLATE_SUGGESTION_UPGRADE_CLICKED: 'emailtemplate_suggestion_upgrade_tooltip_clicked',
    AI_SUMMARIZER_UPGRADE_CLICKED: 'aisummary_upgrade_tooltip_clicked',
    AI_REPHRASE_UPGRADE_CLICKED: 'airephrase_upgrade_tooltip_clicked',
    REMOVE_CONVERSATION_LOGS_UPGRADE_CLICKED: 'rcl-ap_upgrade_tooltip_clicked',
    CHAT_NUDGES_UPGRADE_CLICKED: 'chat-nudges-ap_upgrade_tooltip_clicked',
};

export const AI_KB_NUDGE_GAINSIGHT = {
    REDIRECT: "AI_EA_nudge_AP_KB_upload_nudge_addKB_clicked",
    LEARN_MORE: "AI_EA_nudge_AP_KB_upload_nudge_learnmore_clicked",
    BOOK_CALL: "AI_EA_nudge_AP_KB_upload_nudge_bookcall_clicked",
    SHOWN: "AI_EA_nudge_AP_KB_upload_nudge_shown"
}

export const AI_COPILOT_SETUP_NUDGE_GS = {
    BOOK_CALL : "AP_Copilot_banner_long_meeting_clicked",
    SETUP_COPILOT : "AP_Copilot_banner_setup_Copilot",
    CLOSE_HOME_NUDGE : "AP_Copilot_banner_dismissed_permanently",
    SNOOZED : "AP_Copilot_banner_dismissed_snoozed",
};